import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { useEffect, useState } from "react";
import { sidebarItems } from "../utils/data";

const Sidebar = () => {
  const [activeLink, setActiveLink] = useState("");

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
    sessionStorage.getItem("aussivo_token");
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  return (
    <aside className="sidebar_wrap">
      {sidebarItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`sidebar_link ${isActive(item.path.replace("/", ""))}`}
        >
          <img src={item.icon} alt={item.label} className="sidebar_icon" />
          <span className="sidebar_txt">{item.label}</span>
        </Link>
      ))}
    </aside>
  );
};

export default Sidebar;
